<template>
  <!-- 实训目标文件部分 -->
  <div class="target-verification-file">
    <div class="dataset-get dataset-get-line">
      <div>
        <el-button
          type="primary"
          :class="['btn-upload', {'events-disable': releaseStatus || modelLimitButtonShow}]"
          @click="uploadPictures"
          v-if="teacherOrStudentState"
        >上传目标校验{{modelTypeCompany(modelType)}}</el-button>
        <div class="target-tips" v-else>* 目标校验{{modelTypeCompany(modelType)}}将默认作为校验所训练模型的{{modelTypeCompany(modelType)}}</div>
      </div>
      <div class="go-to-dataset" @click="onTargetFile('1')">
        <i class="el-icon el-icon-right"></i>
        <span>{{modelTypeText(modelType)}}</span>
      </div>
    </div>
    <TrainingFileList 
      :modelType="modelType"
      :teacherOrStudentState="teacherOrStudentState"
      :PicturesData="PicturesData"
      @getTargetFile="getTargetFile"
      :modelLimitButtonShow="modelLimitButtonShow"
      :releaseStatus="releaseStatus"
    ></TrainingFileList>
  </div>
  
</template>

<script>
import TrainingFileList from './TrainingFileList.vue'

export default {
  name: "TargetVerificationFile",
  components: { TrainingFileList },
  props: {
    PicturesData: {
      type: Array,
      default: []
    },
    teacherOrStudentState: {
      type: Boolean,
      default: false
    },
    modelType: {
      type: String,
      default: '1'
    },
    modelLimitButtonShow: {
      type: Boolean,
      default: false
    },
    releaseStatus: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      fileUrl: '',
      popupActive: '',
      currentPage: 1, // 分页器当前页面
      Pictures: {
        records: [], // 文件列表
        size: 20,
        current: 1,
        total: 0,
      },
      imgPreviewUrl: '',
      dialogvisibleview: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    modelTypeText(type) {
      if (type == 1 || type == 3 || type == 5) {
        return `${this.modelTypeCompany(type)}分类`;
      } else if (type == 2) {
        return '标注数据';
      } else if (type == 4 || type == 6) {
        return `${this.modelTypeCompany(type)}标注`;
      }
    },
    // 获取目标文件
    getTargetFile() {
      this.$emit('getTargetFile');
    },
    uploadPictures() {
      this.$emit('uploadPictures');
    },
    onTargetFile(val) {
      this.$emit('onTargetFile', val);
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
.target-verification-file {
  .dataset-get-line {
    border-bottom: 1px solid #d1daf0;
  }
  .dataset-get {
    height: 84px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .target-tips {
      color: #F56C6C;
      background-color: #fef0f0;
      border-radius: 5px;
      padding: 10px;
    }
    .btn-upload {
      background-color: #4C88FF;
      border: 1px solid #4C88FF;
    }
    .go-to-dataset {
      color: #4c88ff;
      font-size: 14px;
      font-weight: bold;
      cursor: pointer;
      .el-icon-right {
        margin-right: 5px;
        font-weight: bold;
      }
    }
  }
}
</style>
